import React, { useState ,useEffect} from "react";
import "./registrationfrom.css";
import Swal from "sweetalert2";
import Address from "./Address";
import GuardianInfo from "./GuardianInfo";
import CustomFields from "./CustomFields";
import PersonalInfo from "./PersonalInfo";
import EducationDetails from "./EducationDetails";
import { API_BASE_URL } from "../../Config/Config";

function StudentRegistrationForm({dataClient}) {
  const [personalInfo, setPersonalInfo] = useState({});
  const [address, setAddress] = useState({});
  const [educationDetails, setEducationDetails] = useState({});
  const [gaurdianInfo, setGaurdianInfo] = useState({});

  const client_id = dataClient?.client_schema_name[6][0].client_id;
  const user_name = dataClient?.client_schema_name[6][0].user_name;
  const client_branch_id = dataClient?.client_schema_name[6][0].client_branch_id;

          
  const handleSubmit = async () => {
    try {
      if (!validateForm()) {
        throw new Error("Please fill all required fields");
      }
  
      if (
        (gaurdianInfo.fathers_name === "" || gaurdianInfo.fathers_mob_no === "") &&
        (gaurdianInfo.mothers_name === "" || gaurdianInfo.mothers_mob_no === "")
      ) {
        throw new Error("Please provide either father's or mother's information");
      }
  
      // Create FormData object
      const formData = new FormData();
  
      // Create base student data object
      const studentData = {
        ...personalInfo,
        ...educationDetails,
        ...address,
        ...gaurdianInfo,
        enquiry_id: personalInfo.enquiry_id || null,
        emergency_contact_name: "Not Available",
        status: 1,
        last_modified_date: new Date().toISOString(),
        last_modified_by: user_name,
        create_date: new Date().toISOString(),
        created_by: user_name,
        client_branch_id: client_branch_id,
        client_id: client_id,
        delete_flag: 0,
        // Add these fields with empty values if not present
        board_id_5: null,
        pass_year_5: "",
        school_name_5: "",
        percentage_cgpa_5: "",
        board_id_6: null,
        pass_year_6: "",
        school_name_6: "",
        percentage_cgpa_6: "",
        board_id_7: null,
        pass_year_7: "",
        school_name_7: "",
        percentage_cgpa_7: "",
        board_id_8: null,
        pass_year_8: "",
        school_name_8: "",
        percentage_cgpa_8: "",
        board_id_9: null,
        pass_year_9: "",
        school_name_9: "",
        percentage_cgpa_9: "",
        board_id_10: null,
        pass_year_10: "",
        school_name_10: "",
        percentage_cgpa_10: "",
        board_id_11: null,
        pass_year_11: "",
        school_name_11: "",
        percentage_cgpa_11: "",
        board_id_12: null,
        pass_year_12: "",
        school_name_12: "",
        percentage_cgpa_12: "",
        guardian_name: "",
        guardian_mob_no: "",
        guardian_relation: null,
        comments_: ""
      };
  
      // Handle image if it exists
      if (personalInfo.IMG) {
        const photograph = personalInfo.IMG;
        // Remove IMG from studentData if it exists
        const { IMG, ...dataWithoutImage } = studentData;
        
        // Append the image file
        formData.append('photograph', photograph);
        
        // Append the student data without image
        formData.append('student_data', JSON.stringify(dataWithoutImage));
      } else {
        // If no image, just append the student data
        formData.append('student_data', JSON.stringify(studentData));
      }
  
      // Log form data for debugging
      console.log('Form submission data:', {
        hasImage: formData.has('photograph'),
        formDataEntries: Array.from(formData.keys())
      });
  
      // Make the API call
      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/new-student`,
        {
          method: 'POST',
          body: formData
        }
      );
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || errorData.message || "Failed to submit form");
      }
  
      const responseData = await response.json();
  
      if (responseData.result === "success") {
        Swal.fire({
          title: "Success",
          text: responseData.message,
          icon: "success",
          confirmButtonColor: "#318682",
        });
        resetForm();
      } else {
        Swal.fire({
          title: "Failed to register",
          text: responseData.message || "Registration failed",
          icon: "warning",
          confirmButtonColor: "#318682",
        });
      }
    } catch (error) {
      console.error('Form submission error:', error);
      Swal.fire({
        title: "Error in submitting the form",
        text: error.message,
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
    }
  };
  // const handleSubmit = async () => {
  //   try {
  //     if (!validateForm()) {
  //       throw new Error("Please fill all required fields");
  //     }

  //     if (
  //       (gaurdianInfo.fathers_name === "" ||
  //         gaurdianInfo.fathers_mob_no === "") &&
  //       (gaurdianInfo.mothers_name === "" || gaurdianInfo.mothers_mob_no === "")
  //     ) {
  //       throw new Error(
  //         "Please provide either father's or mother's information"
  //       );
  //     }

  //     const formData = {
  //       ...personalInfo,
  //       ...educationDetails,
  //       ...address,
  //       ...gaurdianInfo,
  //       emergency_contact_name: "Not Available",
  //       status: 1,
  //       last_modified_date: "2024-03-21T16:53:26.603Z",
  //       last_modified_by: "Admin",
  //       create_date: "2024-03-21T16:53:26.603Z",
  //       created_by: "Admin",
  //       client_branch_id: 1,
  //       client_id: 1,
  //     };

  //     if (personalInfo.enquiry_id !== null) {
  //       formData.enquiry_id = personalInfo.enquiry_id;
  //     }

  //     const response = await fetch(
  //       `${API_BASE_URL}/coaching-collaborator-api/api/v1/new-student`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(formData),
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error("Failed to submit form");
  //     }

  //     const responseData = await response.json();

  //     if (responseData.result === "success") {
  //       Swal.fire({
  //         title: "Success",
  //         text: responseData.message,
  //         icon: "success",
  //         confirmButtonColor: "#318682",
  //       });
  //       resetForm();
  //     } else {
  //       // Handle non-error message
  //       Swal.fire({
  //         title: "Failed to register",
  //         text: responseData.message,
  //         icon: "warning",
  //         confirmButtonColor: "#318682",
  //       });
  //     }
  //   } catch (error) {
  //     Swal.fire({
  //       title: "Error in submitting the form",
  //       text: error.message,
  //       icon: "error",
  //       confirmButtonColor: "rgb(100 101 101)",
  //     });
  //   }
  // };
  // console.log("Image being sent:", personalInfo.IMG);
  const validateForm = () => {
    // Check if all required fields have personalInfo
    if (
      personalInfo.roll_number === "" ||
      personalInfo.class_type_id === null ||
      personalInfo.student_first_name === "" ||
      personalInfo.date_of_birth === "" ||
      personalInfo.gender_id === 0 ||
      personalInfo.student_mob_no === "" ||
      personalInfo.emrgency_contact_mob_no === "" ||
      personalInfo.course_id === null ||
      educationDetails.current_class_id === null ||
      educationDetails.education_medium_id === null ||
      address.loc_add1 === "" ||
      address.loc_city_id === null ||
      address.perm_add1 === "" ||
      address.perm_city_id === ""
    ) {
      return false; // Not all required fields are filled
    }
    return true; // All required fields are filled
  };

  const handleCancel = () => {
    Swal.fire({
      title: "Are you sure you want to cancel?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "rgb(100 101 101)",
      cancelButtonColor: "#318682",
    }).then((result) => {
      if (result.isConfirmed) {
        resetForm();
      }
    });
  };

  const resetForm = () => {
    setPersonalInfo({});
    setEducationDetails({});
    setAddress({});
    setGaurdianInfo({});
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

    // Add useEffect to monitor personalInfo changes
    useEffect(() => {
      if (personalInfo.IMG) {
        console.log('StudentRegistrationForm - Received image:', {
          imageSize: personalInfo.IMG.size,
          imageType: personalInfo.IMG.type,
          imageName: personalInfo.IMG.name
        });
      }
    }, [personalInfo]);
  return (
    <div className="create-role-container">
      <div className="create-role-container-one">
        <span className="create-role-heading">Student Registration Form</span>
        <div className="cr-header-btn-container">
          <button className="cr-cancel-btn" onClick={handleCancel}>
            CANCEL
          </button>
          <button className="cr-create-btn" onClick={handleSubmit}>
            SAVE
          </button>
        </div>
      </div>
      <PersonalInfo setPersonalInfo={setPersonalInfo} />
      <EducationDetails setEducationDetails={setEducationDetails} />
      <Address setAddress={setAddress} />
      <GuardianInfo setGaurdianInfo={setGaurdianInfo} />
      <CustomFields />
    </div>
  );
}
export default StudentRegistrationForm;
